import { ActionType, getType } from 'typesafe-actions';
import * as actions from '@actions/risk-record';
import { RiskRecord } from '@rootCommon/types/cancerRisk';
import { ResultState } from '@rootCommon/types/common';

type Action = ActionType<typeof actions>;
export type RiskRecordState = ResultState<RiskRecord | null>;

const initState: RiskRecordState = {
  data: null,
  loading: false,
  error: null,
};

export const riskRecordReducer = (state = initState, action: Action): RiskRecordState => {
  switch (action.type) {
    // fetch
    case getType(actions.fetchRiskRecord.request):
      return { ...state, loading: true };
    case getType(actions.fetchRiskRecord.success):
      return { ...state, loading: false, data: action.payload };
    case getType(actions.fetchRiskRecord.failure):
      return { ...state, loading: false, error: action.payload };

      // update
    case getType(actions.updateRiskRecord.request):
      return { ...state, loading: true };
    case getType(actions.updateRiskRecord.success):
      return { ...state, loading: false, data: action.payload };
    case getType(actions.updateRiskRecord.failure):
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default riskRecordReducer;
